import AccessibilityNewRoundedIcon from "@mui/icons-material/AccessibilityNewRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import AlertTriangleRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import DirectionsBusFilledRoundedIcon from "@mui/icons-material/DirectionsBusFilledRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import HeadsetMicRoundedIcon from "@mui/icons-material/HeadsetMicRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import LocalFloristRoundedIcon from "@mui/icons-material/LocalFloristRounded";
import LuggageRoundedIcon from "@mui/icons-material/LuggageRounded";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import MessageRoundedIcon from "@mui/icons-material/MessageRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import PetsRoundedIcon from "@mui/icons-material/PetsRounded";
import PhoneInTalkRoundedIcon from "@mui/icons-material/PhoneInTalkRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import TimerRoundedIcon from "@mui/icons-material/TimerRounded";
import WaterDropRoundedIcon from "@mui/icons-material/WaterDropRounded";
import WbSunnyRoundedIcon from "@mui/icons-material/WbSunnyRounded";
import WhatshotRoundedIcon from "@mui/icons-material/WhatshotRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import ConfirmationNumberRoundedIcon from "@mui/icons-material/ConfirmationNumberRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

/** Ícones aceitos pelo site Guerino (`institutionalIcon`). */
export const INSTITUTIONAL_ICON_OPTIONS = [
  { id: "bus", label: "Ônibus", Icon: DirectionsBusFilledRoundedIcon },
  { id: "bus-front", label: "Ônibus (frente)", Icon: DirectionsBusFilledRoundedIcon },
  { id: "shield", label: "Proteção", Icon: ShieldRoundedIcon },
  { id: "shield-check", label: "Segurança verificada", Icon: SecurityRoundedIcon },
  { id: "phone", label: "Telefone", Icon: PhoneInTalkRoundedIcon },
  { id: "headset", label: "Atendimento", Icon: HeadsetMicRoundedIcon },
  { id: "award", label: "Prêmio / qualidade", Icon: EmojiEventsRoundedIcon },
  { id: "map-pinned", label: "Mapa / local", Icon: MapRoundedIcon },
  { id: "baggage", label: "Bagagem", Icon: LuggageRoundedIcon },
  { id: "file-text", label: "Documento", Icon: DescriptionRoundedIcon },
  { id: "paw", label: "Animal de estimação", Icon: PetsRoundedIcon },
  { id: "timer", label: "Tempo / prazo", Icon: TimerRoundedIcon },
  { id: "alert", label: "Atenção", Icon: AlertTriangleRoundedIcon },
  { id: "flame", label: "Urgência", Icon: WhatshotRoundedIcon },
  { id: "heart", label: "Cuidado", Icon: FavoriteRoundedIcon },
  { id: "package", label: "Encomenda", Icon: Inventory2RoundedIcon },
  { id: "users", label: "Pessoas", Icon: GroupsRoundedIcon },
  { id: "accessibility", label: "Acessibilidade", Icon: AccessibilityNewRoundedIcon },
  { id: "graduation-cap", label: "Estudante", Icon: SchoolRoundedIcon },
  { id: "badge-percent", label: "Desconto", Icon: BadgeRoundedIcon },
  { id: "sun", label: "Sustentabilidade (sol)", Icon: WbSunnyRoundedIcon },
  { id: "droplets", label: "Água", Icon: WaterDropRoundedIcon },
  { id: "leaf", label: "Meio ambiente", Icon: LocalFloristRoundedIcon },
  { id: "briefcase", label: "Trabalho", Icon: BusinessCenterRoundedIcon },
  { id: "building", label: "Empresa", Icon: AccountBalanceRoundedIcon },
  { id: "ticket", label: "Passagem", Icon: ConfirmationNumberRoundedIcon },
  { id: "wallet", label: "Pagamento", Icon: PaymentsRoundedIcon },
  { id: "settings", label: "Configuração", Icon: SettingsRoundedIcon },
  { id: "message", label: "Mensagem", Icon: MessageRoundedIcon },
  { id: "sparkles", label: "Destaque", Icon: AutoAwesomeRoundedIcon },
];

export const HOME_EMOJI_OPTIONS = [
  "🎟️",
  "♿",
  "🚌",
  "💳",
  "📱",
  "🛡️",
  "⭐",
  "💚",
  "🤝",
  "📍",
  "⏱️",
  "✅",
];

export const IMAGE_SIZE_HINTS = {
  hero: {
    title: "Imagem de abertura (banner grande)",
    dimensions: "Recomendado: 1920 × 800 px (paisagem)",
    maxMb: 5,
  },
  banner: {
    title: "Imagem de destaque",
    dimensions: "Recomendado: 1200 × 500 px",
    maxMb: 5,
  },
  content: {
    title: "Imagem de conteúdo",
    dimensions: "Recomendado: mínimo 800 × 600 px",
    maxMb: 5,
  },
  poster: {
    title: "Capa do vídeo",
    dimensions: "Recomendado: 1280 × 720 px (16:9)",
    maxMb: 5,
  },
};
